import { ReactElement } from 'react';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';

interface LoadingSkeletonProps extends SkeletonProps {
  children: ReactElement;
  loading: boolean;
}

export const LoadingSkeleton = ({
  children,
  loading,
  ...rest
}: LoadingSkeletonProps) => {
  if (!loading) return children;

  return <Skeleton {...rest} />;
};
